'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';


$(document).ready(function(){
	if (!$("#popup_window").length) { // init if not in dialog view
		blocks_people_diagram();
		blocks_accordions();
		blocks_tabs();
		blocks_map();
		blocks_slider();
	}
});


function blocks_map(){
	if ($("#single_blocks_map").length){
		var $wrapper = $(".location_map");
		var map = new google.maps.Map(document.getElementById('single_blocks_map'), {
          zoom: 14,
          center: new google.maps.LatLng($wrapper.data("lat"), $wrapper.data("lng")),
          mapTypeId: 'roadmap'
        });

		var iconBase = $wrapper.data("folder");
		var marker = new google.maps.Marker({
			position: new google.maps.LatLng($wrapper.data("lat"), $wrapper.data("lng")),	
			map: map,
			icon: {
				url: iconBase + '/pin_lblue.png',
				scaledSize : new google.maps.Size(29, 39)
			},
		});
		google.maps.event.addDomListener(window, "resize", function() {
			var center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.setCenter(center); 
		});
	}
}


function blocks_people_diagram(){
	if ($(".infographic_peoples").length){
		$(".people_diagram").each(function(){
			var $diagram = $(this);
			$(".one_color", $diagram).each(function(){
				var $t = $(this);
				var percent = Math.round($t.data("percent"));
				for (var i = 0; i < percent; i++){
					$t.append("<span class='icon-person2'></span>");
				}
			});
			
			if ($(".icon-person2", $diagram).length == 99){
				$(".one_color:last").append("<span class='icon-person2'></span>");
			}
		});
	}
}

function blocks_accordions(){
	$(".vertical_accordion .accordion_title").click(function(){
		var $desc = $(this).next();
		$(this).closest(".interactive_accordion").find(".accordion_title").not(this).removeClass("toggled");
		$(this).closest(".interactive_accordion").find(".accordion_desciption").not($desc).slideUp("fast");
		$(this).toggleClass("toggled").next().slideToggle("fast");
	});
	$(".horizontal_accordion .accordion_title").click(function(){
		if ($(window).width() > 1200){
			var $desc = $(this).next();
			$(this).closest(".interactive_accordion").find(".accordion_title").not(this).removeClass("toggled");
			$(this).closest(".interactive_accordion").find(".accordion_desciption").not($desc).removeClass("showed");
			$(this).toggleClass("toggled").next().removeAttr("style").toggleClass("showed");
		}
		else{
			var $desc = $(this).next();
			$(this).closest(".interactive_accordion").find(".accordion_title").not(this).removeClass("toggled");
			$(this).closest(".interactive_accordion").find(".accordion_desciption").not($desc).slideUp("fast");
			$(this).toggleClass("toggled").next().slideToggle("fast");
		}
	});
}

function blocks_tabs(){ 
	$(".tabs_buttons > div").click(function(){
		var t = $(this).data("target");
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		$(this).parent().parent().next().find(".one_tab").hide();
		$("#"+t).show();
	});
	
	$(".interactive_tabs").each(function(){
		$(".tabs_buttons > div:first", $(this)).trigger('click');
	});
	
	$(".view_more_blocks a").click(function(){
		$(this).parent().prev().removeClass("hide_more_than_9");
		$(this).remove();
		$('.type_links .actual_links a').responsiveEqualHeightGrid();
	});
}

function blocks_slider(){ 
	if ($(".interactive_slider").length){
		$(".interactive_slider").slick({
			dots: false,
			arrows: true,
			speed: 500,
		});
	}
	if ($(".blocks_slider").length){
		$(".blocks_slider").slick({
			dots: false,
			arrows: true,
			speed: 500,
		});
	}
}